import React, { Component } from "react";
import { Base } from "zina-dogi-react";
import { CostPackageBySSOTReportComponent } from "../components";

class CostPackageBySSOTReportContainer extends Component {
    render() {
        const { extraProps } = this.props;
        const base_op = {
            className: "Cost package by SSOT item Report",
            title: "Cost package by SSOT item Report",
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "Cost package by SSOT item Report" }],
            extraProps,
            loading: false
        };
        return (
            <Base {...base_op}>
                <CostPackageBySSOTReportComponent />
            </Base>
        );
    }
}

export default CostPackageBySSOTReportContainer;
